class RedeleaseShare extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-share-button]');
    this.feedback = this.querySelector('[data-share-feedback]');
    if (!this.button) return;

    this.button.addEventListener('click', () => this.#handleShare());
  }

  #setFeedback(message) {
    if (!this.feedback) return;
    this.feedback.textContent = message;
  }

  async #handleShare() {
    const shareData = {
      title: this.dataset.productTitle || document.title,
      text: this.dataset.productTitle || document.title,
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        this.#setFeedback('');
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(window.location.href);
        this.#setFeedback('Link copiado.');
        return;
      }

      this.#setFeedback('Compartilhamento indisponivel neste navegador.');
    } catch (error) {
      this.#setFeedback('');
    }
  }
}

if (!customElements.get('redelease-share')) {
  customElements.define('redelease-share', RedeleaseShare);
}
